// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__s7LPr","title":"Card_title__lwKnk","valueWrapper":"Card_valueWrapper__1gCKQ","icon":"Card_icon__3Y5dj","value":"Card_value__bE3T3","hide":"Card_hide___yS3K"};